export default {
  namespaced: true,
  state: {
    followersList: {
      show: false,
      type: "",
      id: null,
    },
    sebi_number: null,
    toggle_application_successful_modal_flag: false,
    toggle_merge_successful_modal_flag: false,
    toggle_merge_profiles_modal_flag: false,
    toggle_contact_verify_successful_modal_flag: false,
    toggle_delete_existing_profile_modal_flag: false,
    existing_user_for_merge_profile: null,
    questionModal: {
      show: false,
    },
    reportModal: {
      show: false,
    },
    qsnModal: {
      show: false,
    },
  },
  getters: {
    getShow: (state) => state.followersList.show,
    getSebiNumber: (state) => state.sebi_number,
    getToggleApplicationSuccessfulModalFlag: (state) =>
      state.toggle_application_successful_modal_flag,
    getToggleMergeSuccessfulModalFlag: (state) =>
      state.toggle_merge_successful_modal_flag,
    getToggleMergeProfilesModalFlag: (state) =>
      state.toggle_merge_profiles_modal_flag,
    getToggleContactUpdatedSuccessfulModalFlag: (state) =>
      state.toggle_contact_verify_successful_modal_flag,
    getExistingUserForMergingProfile: (state) =>
      state.existing_user_for_merge_profile,
    getToggleDeleteExistingProfileModalFlag: (state) =>
      state.toggle_delete_existing_profile_modal_flag,
  },
  mutations: {
    TOGGLE_QUESTION_MODAL(state, obj) {
      state.questionModal.show = obj.show ? obj.show : false;
    },
    toggleReportModal(state, obj) {
      state.reportModal.show = obj.show ? obj.show : false;
    },
    toggleQsnModal(state, obj) {
      state.qsnModal.show = obj.show ? obj.show : false;
    },
    TOGGLE_FOLLOWER_LIST(state, obj) {
      if (obj.show) {
        (state.followersList.type = obj.type ? obj.type : ""),
          (state.followersList.id = obj.id ? obj.id : null);
      }
      state.followersList.show = obj.show;
    },
    UPDATE_SEBI_NUMBER(state, payload) {
      state.sebi_number = payload;
    },
    OPEN_APPLICATION_SUCCESSFUL_MODAL(state, payload) {
      state.toggle_application_successful_modal_flag = payload;
    },
    OPEN_MERGE_SUCCESSFUL_MODAL(state, payload) {
      state.toggle_merge_successful_modal_flag = payload;
    },
    OPEN_MERGE_PROFILES_MODAL(state, payload) {
      state.toggle_merge_profiles_modal_flag = payload;
    },
    OPEN_CONTACT_VERIFY_SUCCESSFUL_MODAL(state, payload) {
      state.toggle_contact_verify_successful_modal_flag = payload;
    },
    UPDATE_EXISTING_USER_FOR_MERGING_PROFILE(state, payload) {
      state.existing_user_for_merge_profile = payload;
    },
    OPEN_DELETE_EXISTING_PROFILE_MODAL_FLAG(state, payload) {
      state.toggle_delete_existing_profile_modal_flag = payload;
    },
  },
  actions: {
    toggleFollowerList({ commit }, obj) {
      commit("TOGGLE_FOLLOWER_LIST", obj);
    },
    updateSebiNumber({ commit }, payload) {
      commit("UPDATE_SEBI_NUMBER", payload);
    },
    openApplicationSuccessfulModal({ commit }, payload) {
      commit("OPEN_APPLICATION_SUCCESSFUL_MODAL", payload);
    },
    openMergeSuccessfulModal({ commit }, payload) {
      commit("OPEN_MERGE_SUCCESSFUL_MODAL", payload);
    },
    openMergeProfilesModal({ commit }, payload) {
      commit("OPEN_MERGE_PROFILES_MODAL", payload);
    },
    openContactVerifySuccessfulModal({ commit }, payload) {
      commit("OPEN_CONTACT_VERIFY_SUCCESSFUL_MODAL", payload);
    },
    updateExistingUserForMergingProfile({ commit }, payload) {
      commit("UPDATE_EXISTING_USER_FOR_MERGING_PROFILE", payload);
    },
    openDeleteExistingProfileModal({ commit }, payload) {
      commit("OPEN_DELETE_EXISTING_PROFILE_MODAL_FLAG", payload);
    },
  },
};
